import { Button, Icon, Typography, useTheme } from "@mui/material";
import { Box, Stack } from "@mui/system";

import { ReactComponent as videoCircle } from "assets/video-circle.svg";
import star from "assets/star.svg";
import mobileBg from "assets/mobile-bg.webp";
import { IDarkTheme } from "styles/darkTheme";
import styles from "./styles";
import { forwardRef, useState } from "react";
import ModalComponent from "components/SharedComponents/Modal";
import { DemoVideo } from "utils/constants";
import { useCurrentUser } from "app/appHooks";

type IDemoSectionProps = {
  smPad: string;
  onGetStarted: any;
  isSM: boolean;
  onPricingClick: () => void;
};
const DemoSection = forwardRef(
  ({ isSM, smPad, onGetStarted, onPricingClick }: IDemoSectionProps, ref) => {
    const theme = useTheme<IDarkTheme>();
    const classes = styles();
    const [openModal, setOpenModal] = useState<boolean>(false);
    const { data: user } = useCurrentUser();
    const closeModal = () => {
      setOpenModal(false);
    };
    const viewDemo = () => {
      setOpenModal(true);
    };
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundImage: { xs: `url(${mobileBg})`, md: "none" },
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: { xs: "80px 0", md: "0" }
        }}
      >
        <Stack
          sx={{
            marginLeft: { xs: "auto", md: "48px" },
            marginRight: { xs: "auto" },
            maxWidth: { xs: "100%", md: "446px" },
            alignItems: { xs: "center", md: "start" }
          }}
        >
          <Typography
            className={classes.saveYour}
            variant="h2"
            sx={{
              fontWeight: `${theme.fontWeight.big} !important`,
              textAlign: { xs: "center", lg: "left" }
            }}
          >
            Celebrate
          </Typography>
          <Typography variant="h2" className={classes.moneyNow}>
            Team Wins
          </Typography>
          <p ref={ref as any} className={classes.featureDescription}>
            Hoya makes it easy to celebrate your team’s success. Join now and
            create a culture of appreciation and teamwork
          </p>
          <img
            src={`${process.env.PUBLIC_URL}/hero-mobile.webp`}
            alt={"HoyaApp hero"}
            width={590}
            height={627}
            {...{ fetchpriority: "high" }}
            className={classes.heroImgMobile}
          />

          <Stack
            direction={"row"}
            gap={"16px"}
            sx={{
              marginTop: "32px",
              justifyContent: { xs: "center", md: "start" }
            }}
            alignSelf={isSM ? "center" : "start"}
            width="100%"
          >
            <Button
              onClick={onGetStarted}
              variant="outlined"
              className={classes.lightBtn}
            >
              {user ? "View Dashboard" : "Get Started"}
            </Button>
            <Button
              variant="outlined"
              onClick={viewDemo}
              sx={{
                color: { xs: "white", md: theme.colors.neutrals.neutrals_90 },
                border: { xs: "1px solid white", md: "none" },
                textTransform: "none",
                borderRadius: "10px",
                fontSize: theme.fontSize.bodyText_1,
                fontWeight: theme.fontWeight.bold,
                fontFamily: theme.fontFamily.montserrat,
                padding: isSM ? "4px 8px !important" : undefined,
                "&:hover": {
                  border: "none"
                }
              }}
              startIcon={
                <Icon
                  sx={{
                    scale: "2",
                    marginRight: "8px"
                  }}
                  component={videoCircle}
                />
              }
            >
              View Demo
            </Button>
          </Stack>
          {/* Promotional Banner */}
          <Box
            sx={{
              mt: "30px",
              ml: { xs: "-100px", md: "-12px" },
              mx: { xs: "auto" },
              padding: "12px 16px",
              borderRadius: "360px",
              position: "relative",
              background: "linear-gradient(90deg, #FE4133 0%, #FFB805 100%)",
              color: "white",
              whiteSpace: "nowrap"
            }}
          >
            <img
              src={star}
              className={classes.rightSideStar}
              alt="star"
              {...{ fetchpriority: "high" }}
            />
            <img
              src={star}
              className={classes.leftSideStar}
              alt="star"
              {...{ fetchpriority: "high" }}
            />
            <Typography
              onClick={onPricingClick}
              sx={{ cursor: "pointer", fontSize: { xs: "12px", md: "16px" } }}
            >
              <strong>10 Free recognitions per month</strong>, then its only{" "}
              <strong className={classes.price}>$29.99/month</strong>
            </Typography>
          </Box>
        </Stack>
        <ModalComponent openModal={openModal} handleClose={closeModal}>
          <Box
            component={"video"}
            controls
            sx={{ width: "100%", height: "90%" }}
          >
            <source src={DemoVideo} />
          </Box>
        </ModalComponent>
        <img
          src={`${process.env.PUBLIC_URL}/hero.webp`}
          alt={"HoyaApp hero"}
          width={2030}
          height={1474}
          {...{ fetchpriority: "high" }}
          className={classes.heroImg}
        />
      </Box>
    );
  }
);

export default DemoSection;
